import React from "react";
import PropTypes from "prop-types";

import envelopeIcon from "../images/socials/envelope.svg";
import gitHubIcon from "../images/socials/github.svg";
import linkedInIcon from "../images/socials/linkedin.svg";

const Footer = ({ name, email, gitHub, linkedIn }) => {
  return (
    <div
      id="contact"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2rem",
        padding: "5rem 0 3rem",
        borderTop: "1px solid #242424",
      }}
    >
      <p style={{ fontSize: "0.65rem", fontWeight: 700, letterSpacing: "0.2em", textTransform: "uppercase", color: "#8b93c8", margin: 0 }}>
        Contact
      </p>
      <p style={{ color: "#888", margin: 0, fontSize: "14px" }}>
        <a href={`mailto:${email}`} style={{ color: "#888" }} onMouseEnter={(e) => (e.target.style.color = "#e8e6e1")} onMouseLeave={(e) => (e.target.style.color = "#888")}>
          {email}
        </a>
      </p>
      <div style={{ display: "flex", gap: "1.5rem" }}>
        {email && (
          <a href={`mailto:${email}`} style={{ opacity: 0.45, transition: "opacity 0.2s" }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.45)}>
            <img src={envelopeIcon} alt="email" className="socialIcon" />
          </a>
        )}
        {gitHub && (
          <a href={`https://github.com/${gitHub}`} target="_blank" rel="noopener noreferrer"
            style={{ opacity: 0.45, transition: "opacity 0.2s" }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.45)}>
            <img src={gitHubIcon} alt="GitHub" className="socialIcon" />
          </a>
        )}
        {linkedIn && (
          <a href={`https://www.linkedin.com/in/${linkedIn}`} target="_blank" rel="noopener noreferrer"
            style={{ opacity: 0.45, transition: "opacity 0.2s" }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.45)}>
            <img src={linkedInIcon} alt="LinkedIn" className="socialIcon" />
          </a>
        )}
      </div>
      <p style={{ fontSize: "11px", color: "#333", margin: 0 }}>
        © {new Date().getFullYear()} {name}
      </p>
    </div>
  );
};

Footer.defaultProps = {
  name: "",
};

Footer.propTypes = {
  email: PropTypes.string,
  gitHub: PropTypes.string,
  linkedIn: PropTypes.string,
  name: PropTypes.string.isRequired,
};

export default Footer;
